import { useTranslation } from "react-i18next";

export default function SplashScreen() {
    const { t } = useTranslation();
    return (
        <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
            <div>
                <div className="h3">{t('main:brand')}</div>
                <div className="d-flex justify-content-center">
                    <div className="spinner-border text-dark spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
